import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { DeleteButton } from "./DeleteButton";
import { DownloadButton } from "./DownloadButton";
import "./AbstractUploadInput.scss";
import { LoadingIndicator } from "../components/LoadingIndicator";
import * as Dialogs from "oc-ui/dialogs/Dialogs";
import * as Commons from "oc-commons/Commons";

export const AbstractUploadInput = ({
  property,
  accept = undefined,
  preview,
  incUpdate,
  additionalButtons = (setErrorMessage) => null,
  children = null,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const [uploading, setUploading] = useState(false);

  const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
    accept,
    multiple: false,
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      let file = acceptedFiles[0];
      if (file) {
        setUploading(true);
        setErrorMessage(null);
        property
          .upload(file)
          .then((ok) => {
            incUpdate(setUploading, setErrorMessage);
            APP.sceneNode.callDebouncedUpdateSceneOn(property.node);
          })
          .catch((errorObject) => {
            setUploading(false);
            setErrorMessage(Dialogs.formatAjaxError(errorObject));
          });
      }
    },
  });

  const currentValue = property.get();

  const dropZone = (content) => (
    <div className="container" title="upload">
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        {content()}
      </div>
      {fileRejections.map(({ file, errors }) => (
        <li key={file.name}>
          {file.name} - {file.size} bytes
          <ul>
            {errors.map((e) => (
              <li key={e.code}>{e.message}</li>
            ))}
          </ul>
        </li>
      ))}
    </div>
  );

  const hasValue = !Commons.isEmpty(currentValue);

  const editable = property.editable !== false;

  return (
    <div className="flex-column">
      <div className="upload-input flex-row">
        {hasValue ? (
          <React.Fragment>
            {preview({
              property,
              setUploading,
              setErrorMessage,
              children: () => uploading && <LoadingIndicator className={"dark-background"} />,
            })}
            <div className="flex-column">
              {editable && <DeleteButton property={property} />}
              {hasValue &&
                editable &&
                dropZone(() => <div className="button upload rounded">▲</div>)}
              <DownloadButton property={property} />
              {additionalButtons(setErrorMessage)}
            </div>
          </React.Fragment>
        ) : editable ? (
          uploading ? (
            <React.Fragment>
              <LoadingIndicator />
              <div
                className="delete button rounded"
                onClick={() => setUploading(false)}
                title="Abbrechen"
              >
                ✖
              </div>
            </React.Fragment>
          ) : (
            dropZone(() => <div className="button upload">upload ▲</div>)
          )
        ) : (
          <div>nothing</div>
        )}
      </div>
      {errorMessage != null && (
        <div className="error" dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
      )}
      {children}
    </div>
  );
};
